import { render, staticRenderFns } from "./ViewPointSet.vue?vue&type=template&id=f977af2a"
import script from "./ViewPointSet.vue?vue&type=script&lang=js"
export * from "./ViewPointSet.vue?vue&type=script&lang=js"
import style0 from "./ViewPointSet.vue?vue&type=style&index=0&id=f977af2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports